import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { termsRelatedLinks } from '@/mocks/termsData';

export default function RelatedLinks() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/50 py-16">
      <div className="max-w-[760px] mx-auto px-6 md:px-8">
        <h2 className="font-heading text-lg md:text-xl text-foreground-950 tracking-[0.06em] mb-2">
          {t('terms.related.title')}
        </h2>
        <p className="text-accent-500 text-[13px] md:text-[14px] tracking-[0.12em] mb-5 font-label">
          RELATED LINKS
        </p>
        <div className="w-8 h-[1px] bg-accent-500/40 mb-8"></div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {termsRelatedLinks.map((link, idx) => (
            <Link
              key={link.href}
              to={link.href}
              className="group bg-background-50 border border-background-200/60 px-5 py-5 hover:border-accent-500/30 transition-all duration-300"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-[16px] font-label text-foreground-800 tracking-[0.04em] mb-1.5 group-hover:text-accent-500 transition-colors">
                    {t(`terms.related.${idx}.title`, { defaultValue: link.label })}
                  </h3>
                  <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                    {t(`terms.related.${idx}.desc`, { defaultValue: link.description })}
                  </p>
                </div>
                <i className="ri-arrow-right-up-line text-accent-500/40 group-hover:text-accent-500 transition-colors text-sm mt-0.5 flex-shrink-0"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}